import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import log from "loglevel";
import { call, put, select, takeLatest } from "redux-saga/effects";
import RelatedFilmService from "services/relatedFilmService";
import { actions } from "./relatedFilmsFormActions";
import { formatRelatedFilmToEdit, getFormState, getNewRelatedFilm, getRelatedFilmFormCallback } from "./sagaHelpers";

export function* loadRelatedFilmToEdit() {
    log.debug("toggling form");
    try {
        const { editing, open, id } = yield select(getFormState);
        log.debug(editing, open, id);
        if (editing && open && id) {
            const response = yield call(RelatedFilmService.getRelatedFilm, id);
            log.debug("Relatedfilm ", formatRelatedFilmToEdit(response.data));
            yield put(actions.TOGGLE_RELATED_FILM_FORM.success({ data: formatRelatedFilmToEdit(response.data) }));
        } else if (!id && editing) {
            log.error("No id has been assigned. Check loadRelatedFilmToEdit saga");
            yield put(actions.TOGGLE_RELATED_FILM_FORM.failed());
        } else {
            yield put(actions.TOGGLE_RELATED_FILM_FORM.success());
        }
    } catch (e) {
        log.error(e);
        yield put(actions.TOGGLE_RELATED_FILM_FORM.failed(null, createError(e)));
    }
}

export function* addRelatedFilm() {
    log.debug("adding...");
    try {
        const newRF = yield select(getNewRelatedFilm);
        const callback = yield select(getRelatedFilmFormCallback);
        const response = yield call(RelatedFilmService.createRelatedFilm, newRF);
        callback(response.data);
        yield put(actions.ADD_RELATED_FILM.success(response.data));
    } catch (e) {
        log.debug(e);
        yield put(actions.ADD_RELATED_FILM.failed(null, createError(e)));
    }
}
export function* editRelatedFilm() {
    try {
        const newRF = yield select(getNewRelatedFilm);

        const { id } = yield select(getFormState);
        const callback = yield select(getRelatedFilmFormCallback);
        const response = yield call(RelatedFilmService.editRelatedFilm, { ...newRF, id });
        callback(response.data);
        yield put(actions.EDIT_RELATED_FILM.success());
    } catch (e) {
        log.error(e);
        yield put(actions.EDIT_RELATED_FILM.failed(null, createError(e)));
    }
}

export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.TOGGLE_RELATED_FILM_FORM.sendType, loadRelatedFilmToEdit),
    takeLatest(actions.ADD_RELATED_FILM.sendType, addRelatedFilm),
    takeLatest(actions.EDIT_RELATED_FILM.sendType, editRelatedFilm),
];
